import * as React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import {
  Badge,
  Box,
  Grid,
  Grid2,
  MenuItem,
  Select,
  TextField,
  useMediaQuery,
  Divider,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { useTheme } from "@emotion/react";
import burgerImg from "../../assets/menuBurgerImg.png";
import MenuListCardsComponent from "./MenuListCardsComponent";
import DeleteIcon from "@mui/icons-material/Delete";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import PickupType from "./Checkout";
import Checkout from "./Checkout";
import DeletePopup from "./Deletepopup";
import PaymentMethod from "./PaymentMethod";
import { useDispatch, useSelector } from "react-redux";
import {
  IMG_BASE_URL,
  format_Number,
  getCompanyStatus,
  getHeight,
  send,
} from "../../utils/utils";
import {
  UpdateAddToCartProducts,
  deleteAddToCartProducts,
  setItemCount,
  setSelectedDeleteItem,
  setSupplementInfo,
  setTotalPrice,
  setTotalProductCount,
  setTotalVat,
  setWebshopFileds,
  setWebshopRelatedProductsInfo,
  updateWebshopOpeningHours,
  updateWebshopTimeSlots,
} from "../../store/slice/Webshop.slice";
import {
  getWebshopFields,
  getWebshopOpeningHours,
} from "../../api/Webshop.service";
import dayjs from "dayjs";
import MessagePopup from "./MessagePopup";
import { useLocation, useNavigate } from "react-router-dom";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const SummaryRow = ({ label, value, bold = false }) => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "space-between",
      mb: 1,
      fontWeight: bold ? "bold" : "normal",
    }}
  >
    <Typography>{label}</Typography>
    <Typography>{value}</Typography>
  </Box>
);

export default function Cartdetails({ open, handleClose }) {
  const {
    css
  }=useSelector((store)=> store?.widgetSettings);
  const cartCss = css?.find(
    (item) => item?.cssTabFieldsGroupName === "Cart"
  )?.fields
  const badgeCss = css?.find(
    (item) => item?.cssTabFieldsGroupName === "Badge"
  )?.fields
  const cardsection = css?.find(
    (item) => item?.cssTabFieldsGroupName === "CardSectionWebshop"
  )?.fields
  const {
    shopType,
    webShopProductInfo,
    itemCount,
    supplementsInfo,
    selectedProduct,
    addToCartProducts,
    webshopSettings,
    deliveryType,
    webshopTimeSlots,
    webshopOpeningHours,
    totalProductsCount,
    singleProductTotalIncludeSupp,
    languageWords,
    totalVat,
    totalPrice,
    CurrencyData,
    webShopMenuPosition,
    defaultLanguage,
  } = useSelector((store) => store?.Webshop);
  const currentDate = dayjs();
  const location = useLocation();
  const recommededProducts = location.state;
  const navigate = useNavigate();
  const { key, resType } = useSelector((store) => store?.widgetSettings);
  const dispatch = useDispatch();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("lg"));
  const [openPickupType, setPickUpType] = React.useState(false);
  const [opendelete, setOpenDelete] = React.useState(false);
  const [openPaymentMethod, setOpenPaymentMethod] = React.useState(false);
  const [openMessage, setOpenMessage] = React.useState(false);
  const [imgErr, setImgErr] = React.useState(false);

  const handleDelete = (id) => {
    dispatch(setSelectedDeleteItem(id));
    setOpenDelete(true);
  };
  const ProductPrice = (id, productPrice) => {
    const supplementInfo = supplementsInfo?.find(
      (item) => item?.idproduct == id
    );
    const supplementTotal =
      supplementInfo?.supplements?.reduce(
        (suppAcc, supplement) => suppAcc + (supplement?.price || 0),
        0
      ) || 0;
    const productTotal =
      productPrice * (itemCount[id] || 0) +
      supplementTotal * (itemCount[id] || 0);

    return format_Number(productTotal);
  };
  const getOpeningHours = async () => {
    const currentDate = dayjs();
    const response = await getWebshopOpeningHours(
      currentDate.format("YYYY-MM-DD"),
      key
    );
    if (response.success === false) {
      console.error(response.message);
    } else {
      dispatch(updateWebshopOpeningHours(response));
    }
  };
  React.useEffect(() => {
    getOpeningHours();
  }, []);
  React.useEffect(() => {
    const generateTimeSlots = () => {
      const now = dayjs();
      const todayDate = dayjs(
        webshopOpeningHours?.value?.data?.openingDate
      ).startOf("day");
      const deliveryStart = todayDate
        .add(
          dayjs(
            webshopOpeningHours?.value?.data?.deliveryFrom,
            "HH:mm:ss"
          ).hour(),
          "hour"
        )
        .add(
          dayjs(
            webshopOpeningHours?.value?.data?.deliveryFrom,
            "HH:mm:ss"
          ).minute(),
          "minute"
        );
      const deliveryEnd = todayDate
        .add(
          dayjs(
            webshopOpeningHours?.value?.data?.deliveryTo,
            "HH:mm:ss"
          ).hour(),
          "hour"
        )
        .add(
          dayjs(
            webshopOpeningHours?.value?.data?.deliveryTo,
            "HH:mm:ss"
          ).minute(),
          "minute"
        );

      let startTime = now.add(
        webshopSettings.defaultDeliveryTime +
          webshopSettings.defaultPreparationTime,
        "minute"
      );
      startTime = startTime
        .minute(Math.ceil(startTime.minute() / 15) * 15)
        .second(0);
      if (startTime.isBefore(deliveryStart)) {
        startTime = deliveryStart;
      }
      const slots = [];
      while (startTime.isBefore(deliveryEnd)) {
        slots.push(startTime.format("HH:mm:ss"));
        startTime = startTime.add(15, "minute");
      }
      dispatch(updateWebshopTimeSlots(slots));
    };

    generateTimeSlots();
  }, [webshopOpeningHours]);

  React.useEffect(() => {
    const totalCountProducts = addToCartProducts?.reduce((sum, value) => {
      return sum + itemCount[value.idproduct];
    }, 0);
    dispatch(setTotalProductCount(totalCountProducts));
  }, [itemCount]);

  React.useEffect(() => {
    if (totalProductsCount >= webshopSettings?.minimumOrderQuantity) {
      setOpenMessage(false);
    } else {
      setOpenMessage(true);
    }
  }, [totalProductsCount]);
  function CalculateVat(price, vatPersentage) {
    const vat = (price / (vatPersentage + 100)) * vatPersentage;
    return Math.round(vat * 100) / 100;
  }
  const calculateTotalPrice = (onlyVat = false) => {
    let vatAmount;
    const totalProductsPrice = addToCartProducts?.reduce((acc, product) => {
      let specialPrice = product?.specialPriceFields?.find((price) =>
        currentDate.isBetween(
          dayjs(price.specialpricefrom, "DD-MM-YYYY"),
          dayjs(price.specialpriceto, "DD-MM-YYYY"),
          null,
          "[]"
        )
      );

      const supplementInfo = supplementsInfo?.find(
        (item) => item?.idproduct === product.idproduct
      );

      const supplementTotal =
        supplementInfo?.supplements?.reduce(
          (suppAcc, supplement) => suppAcc + (supplement?.price || 0),
          0
        ) || 0;
      const productTotal =
        ((product?.recommededProducts
          ? product?.relatedproductprice
          : specialPrice
          ? specialPrice?.specialprice
          : product.price) +
          supplementTotal) *
        (itemCount[product.idproduct] || 0);

      vatAmount = webshopSettings?.pricesIncludingVAT
        ? CalculateVat(productTotal, product?.vat || 0)
        : 0;
      return acc + productTotal + vatAmount;
    }, 0);
    if (onlyVat) {
      dispatch(setTotalVat(vatAmount));
      return format_Number(vatAmount);
    }
    dispatch(setTotalPrice(totalProductsPrice));
    return format_Number(totalProductsPrice);
  };

  React.useEffect(() => {
    calculateTotalPrice();
    calculateTotalPrice(true);
  }, [itemCount]);

  const getGuestFieldDetails = async () => {
    const response = await getWebshopFields(key, defaultLanguage);
    if (response.success === false) {
      console.error(response.message);
    } else {
      dispatch(setWebshopFileds(response));
    }
  };
  React.useEffect(() => {
    getGuestFieldDetails();
  }, []);
   const contentRef = React.useRef(null);
  const sendHeight = React.useCallback(() => {
    if (!contentRef.current) return;

    const height = contentRef.current.scrollHeight;

    send(`${height}px`, "100%", "", "0px", "0px", "", "relative");
  }, []);

  React.useLayoutEffect(() => {
    if (!contentRef.current) return;
    sendHeight();
  }, [addToCartProducts, setSelectedDeleteItem]);

  
  return (
    <Box  sx={{width:webShopMenuPosition == 'horizontal' ? "100%" : "94%"}}>
      {webShopMenuPosition == "null" &&
        !getCompanyStatus(
          webshopOpeningHours?.value?.data?.openTime,
          webshopOpeningHours?.value?.data?.closeTime,
          webshopOpeningHours?.value?.data?.companyOpen,
          webshopOpeningHours?.value?.data?.deliveryFrom,
          webshopOpeningHours?.value?.data?.deliveryTo,
          webshopOpeningHours?.value?.data?.delivery,
          deliveryType
        )?.status && (
          <Box
            sx={{
              width: "100%",
              backgroundColor: "#fff3f3",
              borderBottom: "1px solid #f44336",
              boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.05)",
              textAlign: "center",
              py: 1.5,
            }}
          >
            <Typography
              sx={{
                color: "#c62828",
                fontWeight: 600,
                fontSize: "1.1rem",
                fontFamily: "Roboto, sans-serif",
                letterSpacing: "0.5px",
              }}
            >
              {
                getCompanyStatus(
                  webshopOpeningHours?.value?.data?.openTime,
                  webshopOpeningHours?.value?.data?.closeTime,
                  webshopOpeningHours?.value?.data?.companyOpen,
                  webshopOpeningHours?.value?.data?.deliveryFrom,
                  webshopOpeningHours?.value?.data?.deliveryTo,
                  webshopOpeningHours?.value?.data?.delivery,
                  deliveryType
                )?.message
              }
            </Typography>
          </Box>
        )}
       
      <Box
      ref={contentRef}
        sx={{
          backgroundColor: cartCss?.cartdetailBgClr,
          width: "100%",
          ml:
            webShopMenuPosition === "vertical"
              ? isSmallScreen
                ? "50px"
                : "120px"
              : 0,
          px: { xs: 2, sm: 5 },
          py: 4,
          borderRadius: 3,
          boxSizing: "border-box", 
        }}
      >
        <Box sx={{ mb: 2, display: "flex", alignItems: "center" }}>
          <IconButton color="warning" onClick={() => navigate(-1)}>
            <ArrowBackIosNewRoundedIcon />
          </IconButton>
          <Typography
            sx={{
              color: cartCss?.cartdetailTitleTxtClr,
              fontWeight: 700,
              fontSize: "2rem",
              ml: 1,
            }}
          >
            {languageWords?.CartDetails}
          </Typography>
        </Box>
        {addToCartProducts?.map((item, index) => {
          const specialPrice = item?.specialPriceFields?.find((price) =>
            currentDate.isBetween(
              dayjs(price.specialpricefrom, "DD-MM-YYYY"),
              dayjs(price.specialpriceto, "DD-MM-YYYY"),
              null,
              "[]"
            )
          );

          return (
            <Box
              key={index}
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
               
                gap: 3,
                mb: 3,
                p: 2,
                bgcolor: cartCss?.cartdetailCardBgClr,
                borderRadius: 3,
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
              }}
            >
              {item?.imagefilename && !imgErr && (
                <Box
                  sx={{
                    width: { xs: "100%", sm: "150px" },
                    borderRadius: 2,
                    overflow: "hidden",
                  }}
                >
                  <img
                    src={`${IMG_BASE_URL}/upload/WebshopProduct${item?.imagefilename.replace(
                      /\\/g,
                      "/"
                    )}`}
                    alt="product"
                    style={{
                      width: "100%",
                      height: "auto",
                      objectFit: "cover",
                    }}
                    onError={(e) => {
                      setImgErr(true);
                      e.target.style.display = "none";
                    }}
                  />
                </Box>
              )}

              <Box sx={{ flexGrow: 1 }}>
                {/* TITLE + PRICE (DESKTOP) */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 1,
                  }}
                >
                  <Typography sx={{ fontWeight: 600, fontSize: "1.1rem",color:cartCss?.cartdetailTitleTxtClr }}>
                    {item?.displayname || item?.displayName}
                  </Typography>

                  <Box
                    sx={{
                      display: isSmallScreen ? "none" : "flex",
                      alignItems: "center",
                      gap: 2,
                    }}
                  >
                    <Select
                      size="small"
                      value={itemCount[item?.idproduct] || 1}
                      onChange={(e) => {
                        const newCount = parseInt(e.target.value, 10);
                        dispatch(
                          setItemCount({
                            ...itemCount,
                            [item?.idproduct]: newCount,
                          })
                        );
                      }}
                      sx={{ minWidth: 80,borderColor:cartCss?.selectFiledBorderClr
                      }}
                    >
                      {Array.from(
                        {
                          length:
                            webshopSettings?.maxQuantityOfEachProduct || 10,
                        },
                        (_, i) => i + 1
                      ).map((number) => (
                        <MenuItem key={number} value={number}>
                          {number}
                        </MenuItem>
                      ))}
                    </Select>

                    <Typography sx={{ fontWeight: 600, color:cartCss?.cartdetailCardPriceClr }}>
                      {CurrencyData?.value?.currencySymbol}
                      {ProductPrice(
                        item?.idproduct,
                        item?.recommededProducts
                          ? item?.relatedproductprice
                          : specialPrice
                          ? specialPrice?.specialprice
                          : item?.price
                      )}
                    </Typography>
                  </Box>

                  {/* DELETE (MOBILE TOP) */}
                  <IconButton
                    onClick={() => handleDelete(item?.idproduct)}
                    sx={{ display: { xs: "inline-flex", sm: "none" } }}
                  >
                    <DeleteIcon color={cartCss?.deleteIconClr} />
                  </IconButton>
                </Box>

                {/* ✅ SUPPLEMENTS */}
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: 2 }}>
                  {supplementsInfo
                    ?.find((supp) => supp?.idproduct === item?.idproduct)
                    ?.supplements?.map((suppItem, idx) => (
                      <Typography
                        key={idx}
                        variant="caption"
                        sx={{
                          backgroundColor:badgeCss?.BadgeBgClr,
                          color:badgeCss?.BadgeTxtClr,
                          px: 2,
                          py: 1,
                          borderRadius: 1,
                          fontSize: "0.9rem",
                        }}
                      >
                        {suppItem?.displayName}
                      </Typography>
                    ))}
                </Box>

                {/* MOBILE BOTTOM ACTIONS */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: isSmallScreen
                      ? "space-between"
                      : "flex-end",
                    alignItems: "center",
                    gap: 2,
                  }}
                >
                  {isSmallScreen && (
                    <>
                      <Select
                        size="small"
                        value={itemCount[item?.idproduct] || 1}
                        onChange={(e) => {
                          const newCount = parseInt(e.target.value, 10);
                          dispatch(
                            setItemCount({
                              ...itemCount,
                              [item?.idproduct]: newCount,
                            })
                          );
                        }}
                        sx={{ minWidth: 80 }}
                      >
                        {Array.from(
                          {
                            length:
                              webshopSettings?.maxQuantityOfEachProduct || 10,
                          },
                          (_, i) => i + 1
                        ).map((number) => (
                          <MenuItem key={number} value={number}>
                            {number}
                          </MenuItem>
                        ))}
                      </Select>

                      <Typography sx={{ fontWeight: 600, color: "#F37120" }}>
                        {CurrencyData?.value?.currencySymbol}
                        {ProductPrice(item?.idproduct, item?.price)}
                      </Typography>
                    </>
                  )}

                  {/* DELETE (DESKTOP BOTTOM) */}
                  <IconButton
                    onClick={() => handleDelete(item?.idproduct)}
                    sx={{ display: { xs: "none", sm: "inline-flex" } }}
                  >
                    <DeleteIcon  color={cartCss?.deleteIconClr
}/>
                  </IconButton>
                </Box>
              </Box>
            </Box>
          );
        })}

        {totalPrice > 0 && (
          <Box
            sx={{
              bgcolor: cardsection?.cardSectionBgColor,
              p: 3,
              borderRadius: 3,
              boxShadow: cardsection?.cardSectionShadowClr,
              mt: 4,
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2,color:cardsection?.cardSectionTitleClr }}>
              {languageWords?.OrderSummary}
            </Typography>

            {totalPrice < webshopSettings?.freeDeliveryAfterAmount && (
              <SummaryRow
                label={languageWords?.deliverycost}
                value={`${CurrencyData?.value?.currencySymbol} ${format_Number(
                  webshopSettings?.deliveryStandardCost
                )}`}
              />
            )}

            {totalVat > 0 && (
              <SummaryRow
                label={languageWords?.VAT}
                value={`${CurrencyData?.value?.currencySymbol} ${format_Number(
                  totalVat
                )}`}
              />
            )}

            <Divider sx={{ my: 2 }} />

            <SummaryRow
              label={languageWords?.TotalIncludingVAT}
              value={`${CurrencyData?.value?.currencySymbol} ${format_Number(
                totalPrice < webshopSettings?.freeDeliveryAfterAmount
                  ? totalPrice + webshopSettings?.deliveryStandardCost
                  : totalPrice
              )}`}
              bold
            />
          </Box>
        )}
        <Grid2
          container
          spacing={2}
          sx={{ pt: 4, display: "flex", justifyContent: "flex-end" }}
        >
          <Grid2 xs={12} md={6}>
            <Button
              variant="outlined"
              fullWidth
              size="large"
              sx={{
                width: 200,
                borderRadius: "12px",
                backgroundColor: "#ffffff",
                border: "2px solid #F37120",
                color: "#F37120",
                textTransform: "none",
                px: 2,
                py: 1.6,
                transition: "all 0.3s ease",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                gap: 1.5,
                boxShadow: "0 6px 20px rgba(243, 113, 32, 0.1)",
                "&:hover": {
                  backgroundColor: "#fbeae2",
                  borderColor: "#F37120",
                  color: "#F37120",
                  boxShadow: "0 10px 24px rgba(243, 113, 32, 0.2)",
                  transform: "translateY(-2px)",
                },
              }}
              onClick={() =>
                navigate(
                  webShopMenuPosition != "null" ? "/webshopMenuItem" : "/menu"
                )
              }
            >
              {languageWords?.ProceedShopping}
            </Button>
          </Grid2>
          <Grid2 xs={12} md={6}>
            <Button
              variant="contained"
              fullWidth
              size="large"
              sx={{
                width: 200,
                borderRadius: "12px",
                background: "linear-gradient(135deg, #F37120 0%, #FF9F45 100%)",
                boxShadow: "0 6px 20px rgba(243, 113, 32, 0.3)",
                textTransform: "none",
                px: 2,
                py: 1.6,
                transition: "all 0.3s ease",
                "&:hover": {
                  background:
                    "linear-gradient(135deg, #FF8120 0%, #FFB564 100%)",
                  transform: "translateY(-2px)",
                  boxShadow: "0 10px 24px rgba(243, 113, 32, 0.35)",
                },
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                gap: 1.5,
                borderColor: "#F37120",
                color: "#fff",
                "&:hover": { bgcolor: "#fbeae2", borderColor: "#F37120" },
              }}
              onClick={() =>
                navigate(
                  webShopMenuPosition != "null"
                    ? "/webshopMenuItem/checkout"
                    : "/checkout"
                )
              }
            >
              {languageWords?.Checkout} {CurrencyData?.value?.currencySymbol}
              {format_Number(
                totalPrice < webshopSettings?.freeDeliveryAfterAmount
                  ? totalPrice + webshopSettings?.deliveryStandardCost
                  : totalPrice
              )}
            </Button>
          </Grid2>
        </Grid2>

        {openMessage && (
          <Typography
            variant="body2"
            sx={{
              color: "red",
              mt: 3,
              textAlign: "center",
              fontSize: isSmallScreen ? "0.9rem" : "1rem",
            }}
          >
            To continue checkout, you need to select a minimum of{" "}
            {webshopSettings?.minimumOrderQuantity} products.
          </Typography>
        )}
      </Box>

      <DeletePopup
        open={opendelete}
        handleClose={() => setOpenDelete(false)}
        cartClose={handleClose}
      />
      <PaymentMethod
        open={openPaymentMethod}
        handleClose={() => setOpenPaymentMethod(false)}
        
      />
    </Box>
    
  );
}
